import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { businessFilterGroupIsExpandedState, PanelListFilterType } from '@keepeek/commons';
import { Accordion, AccordionSummary, Typography, AccordionDetails, Box } from '@mui/material';
import clsx from 'clsx';
import { useRecoilState } from 'recoil';
import sanitizeHtml from 'sanitize-html';
import DefaultIcon from '../DefaultIcon/index.js';
import SanitizeHtml from '../SanitizeHtml/index.js';
import BusinessFilter from './BusinessFilter.js';

/**
 * Show a Group of FilterComponent
 * Have a condition to not show if no filters is provided into the group
 * @author JBO
 *
 * @param {Omit<PanelListFilterTypeGroup, "key" | "type">} props
 * @returns {JSX.Element | null}
 */
var BusinessFilterGroup = function (_a) {
    var _b, _c, _d;
    var data = _a.data, currentLocale = _a.currentLocale, title = _a.title, _e = _a.KIcon, KIcon = _e === void 0 ? DefaultIcon : _e, dataViewKey = _a.dataViewKey, rest = __rest(_a, ["data", "currentLocale", "title", "KIcon", "dataViewKey"]);
    var _f = (_c = (_b = title === null || title === void 0 ? void 0 : title.find(function (t) { return t.language === currentLocale; })) !== null && _b !== void 0 ? _b : title === null || title === void 0 ? void 0 : title[0]) !== null && _c !== void 0 ? _c : {}, _g = _f.value, titleValue = _g === void 0 ? "" : _g, empty = _f.empty;
    var _h = useRecoilState(businessFilterGroupIsExpandedState({
        key: dataViewKey,
        id: sanitizeHtml((_d = title === null || title === void 0 ? void 0 : title.map(function (t) { return t.value; }).join("").trim().replaceAll(" ", "")) !== null && _d !== void 0 ? _d : data.map(function (d) { return d.key; }).join(""))
    })), expanded = _h[0], setExpanded = _h[1];
    if (data.length === 0) {
        return null;
    }
    return (React__default.createElement(Accordion, { square: true, expanded: expanded, onChange: function () { return setExpanded(function (prev) { return !prev; }); }, className: clsx("BusinessFilterGroup", "BusinessFilterGroup-count-".concat(data.length), expanded && "BusinessFilterGroup-expanded"), "data-testid": "BusinessFilterGroup", disableGutters: true, elevation: 0, sx: {
            backgroundColor: "transparent",
            borderBottom: function (theme) { return "1px solid ".concat(theme.palette.divider); },
            "&:last-child": {
                borderBottom: 0
            },
            "&::before": {
                display: "none"
            }
        } },
        React__default.createElement(AccordionSummary, { className: clsx("BusinessFilterGroup-summary"), expandIcon: React__default.createElement(KIcon, { sx: { fontSize: "0.9rem" }, className: "fa-caret-down" }), sx: {
                ".MuiAccordionSummary-content": {
                    margin: 0
                }
            } }, !empty && (React__default.createElement(Typography, { variant: "body2", sx: { fontWeight: "bold" } }, SanitizeHtml({ html: titleValue })))),
        React__default.createElement(AccordionDetails, null, data.map(function (_a) {
            var key = _a.key, listFilter = __rest(_a, ["key"]);
            return (React__default.createElement(Box, { key: key, sx: { backgroundColor: "white" } },
                listFilter.type === PanelListFilterType.GROUP && (React__default.createElement(BusinessFilterGroup, __assign({ currentLocale: currentLocale, KIcon: KIcon, dataViewKey: dataViewKey }, rest, listFilter))),
                listFilter.type === PanelListFilterType.FILTER && (React__default.createElement(BusinessFilter, __assign({ KIcon: KIcon, dataViewKey: dataViewKey }, rest, listFilter)))));
        }))));
};

export { BusinessFilterGroup as default };
//# sourceMappingURL=BusinessFilterGroup.js.map
